// 前端SDK埋点引入配置
import { getEnvObj } from '@/utils/env'

const initConfig = {
  show_log: false,
  IS_PERFORMANCE_ANALYTICS_ON: true,
  USE_SENSORS: true, // 使用神策
  is_track_single_page: true, // 默认fasle，表示是否开启单页面自动采集 $pageview 功能，SDK 会在 url 改变之后自动采集web页面浏览事件 $pageview。
  use_client_time: true, // 默认fasle，是否使用客户端时间
  send_type: 'image', // 发送数据方式，可选image、ajax、beacon，默认 image
  heatmap: {}, // 点击图配置. 参考 https://manual.sensorsdata.cn/sa/latest/tech_sdk_client_web_all_use-34537687.html
  server_url: window._global['ENV'] === 'PRD' ? 'https://ubs.sf-express.com/sa?project=gjds' : 'https://ubs-access-tst.sf-express.com/sa?project=gjdsgrey',
  ENV: window._global['ENV'] === 'PRD' ? 'PROD' : 'ALPHA',
  APPID: 'e57a0191-5ac9-46da-9d22-c0483b724ea2',
}
const obj = getEnvObj()
const LOGGER_KEY = {
  SIT: {
    secretKey: '11cb4d051ccd81c2491ed68a59b31cbb',
    accessKey: 'fb1d55ff83085c056d34e6fd508b5f78'
  },
  UAT: {
    secretKey: '11cb4d051ccd81c2491ed68a59b31cbb',
    accessKey: 'fb1d55ff83085c056d34e6fd508b5f78'
  },
  PRD: {
    secretKey: '92934ecf48d1cc9ff85706d3298cff9f',
    accessKey: 'ac389fe0db2d2cdceed9183dad9426c9'
  }
}
initConfig.SECRECT_KEY = LOGGER_KEY[obj.ENV].secretKey
initConfig.ACCESS_KEY = LOGGER_KEY[obj.ENV].accessKey
initConfig.URL = obj.LOGGER_URL

// console.log('initConfig', initConfig)

export default initConfig
